import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  background: var(--surface-raised);
  border-radius: 8px;
  box-shadow: var(--elevation-2);
`;

export const Section = styled.section`
  margin-bottom: 32px;
`;

export const Title = styled.h1`
  font-size: 2rem;
  color: var(--text-primary);
  margin-bottom: 24px;
  font-weight: 700;
`;

export const SubTitle = styled.h2`
  font-size: 1.25rem;
  color: var(--action-link);
  margin-bottom: 12px;
  font-weight: 600;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 12px;
  background: var(--surface-canvas);

  tr:nth-child(even) td {
    background: var(--surface-sunken);
  }

  tr:hover td {
    background: var(--surface-sunken);
    transition: background 0.2s;
  }
`;

export const Th = styled.th`
  background: var(--surface-sunken);
  color: var(--text-primary);
  font-weight: 600;
  padding: 8px 10px;
  border: 1px solid var(--border-default);
  text-align: left;
`;

export const Td = styled.td`
  padding: 8px 10px;
  border: 1px solid var(--border-default);
  color: var(--text-primary);
  background: var(--surface-raised);
`;

export const ParecerTextArea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 10px;
  margin-bottom: 8px;
  border: 1px solid var(--border-default);
  border-radius: 4px;
  font-size: 1rem;
  resize: vertical;
  background: var(--surface-canvas);
  color: var(--text-primary);
`;

export const SaveButton = styled.button`
  background: var(--action-primary-surface);
  color: var(--text-on-inverse);
  border: none;
  border-radius: 4px;
  padding: 8px 18px;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 24px;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: var(--action-primary-surface);
  }
`;

export const ReturnButton = styled.button`
  background: var(--action-primary-surface);
  color: var(--text-on-inverse);
  border: none;
  border-radius: 4px;
  padding: 8px 18px;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 24px;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
  background: var(--action-primary-surface);
  }
  `;